import { Injectable } from "@angular/core";
import { Canal } from "src/app/domain/Endoscope/canal";
import { Endoscope } from "src/app/domain/Endoscope/endoscope";
import { Flacon } from "src/app/domain/flacon";
import { mapper } from "src/app/tools/mapping/mapper";
import {  db   } from "../db";
import { CanalRepository } from "./canal.repository";
import { FlaconRepository } from "./flacon.repository";
import { EndoscopeEntity } from "../endoscope.entity";
import { InterventionEntity } from "../intervention.entity";
import { CanalEntity } from "../canal.entity";
import { FlaconEntity } from "../flacon.entity";

@Injectable({
    providedIn: 'root',
})
export class EndoscopeRepository {
    constructor(
        private canalRepository: CanalRepository,
        // private interventionRepository: InterventionRepository,
        private flaconRepository: FlaconRepository

    ) { }

    async changeEndoscopeTaskStatus(endoscope: Endoscope) {
        const ee = await this.getEndoscopeEntityByCode(endoscope.Code)
        if (!ee || !ee.Id) {
            return;
        }
        await db.endoscopes.update(ee.Id, {
            TaskStatus: endoscope.TaskStatus
        });
        return true;
    }

    async getEndoscopeEntityById(id: number) {
        return await db.endoscopes.where('Id').equals(id).first(async ze => {
            return ze;
        });
    }

    async getEndoscopeById(id: number) {
        return await db.endoscopes.where('Id').equals(id).first(async ze => {
            const z = mapper.map(ze, EndoscopeEntity, Endoscope);
            if (ze?.CanalIds) {
                for (let i = 0; i < ze.CanalIds.length; i++) {
                    z.CanalEndoscopeList.push(await this.canalRepository.getCanalById(ze.CanalIds[i]));
                }
            }

            return z;
        });
    }

    async getEndoscopeEntityByCode(code: string) {
        return await db.endoscopes.where('Code').equals(code).first(async me => {
            return me;
        });
    }

    async getEndoscopeByCodeWithChildren(code: string) {
        return await db.endoscopes.where('Code').equals(code).first(async ze => {
            const z = mapper.map(ze, EndoscopeEntity, Endoscope);

            if (ze?.CanalIds) {
                for (let i = 0; i < ze.CanalIds.length; i++) {
                    z.CanalEndoscopeList.push(await this.canalRepository.getCanalById(ze.CanalIds[i]));
                }
            }

            return z;
        });
    }

    async attachEndoscope(endoscope: Endoscope, interventionEntity: InterventionEntity) {
        let endoId: number;
        const ae = mapper.map(endoscope, Endoscope, EndoscopeEntity);

        // const ie = await this.interventionRepository.getInterventionEntityById(interventionId);
        endoId = await db.endoscopes.add(ae);
        interventionEntity.EndoscopeIds = interventionEntity?.EndoscopeIds ? [...interventionEntity.EndoscopeIds, endoId] : [endoId]
        await db.interventions.update(interventionEntity.Id!, {
            EndoscopeIds: interventionEntity?.EndoscopeIds
        });

        if (endoscope.CanalEndoscopeList?.length > 0) {
            for (let i = 0; i < endoscope.CanalEndoscopeList.length; i++) {
                await this.canalRepository.attachCanal(endoscope.CanalEndoscopeList[i], (await this.getEndoscopeEntityById(endoId))!);
                // await this.canalRepository.attachCanal(endoscope.CanalEndoscopeList[i], endoId);
            }
        }

        return endoId;
    }

    async updateEndoscope(endo: Endoscope) {
        let ee = await this.getEndoscopeEntityByCode(endo.Code);
        if (!ee || !ee.Id) {
            return false;
        }

        if (ee.CanalIds.length > 0) {
            for (let i = 0; i < ee.CanalIds?.length; i++) {
                let pae = await this.canalRepository.getCanalEntityById(ee.CanalIds[i]);
                if (pae) {
                    mapper.mutate(endo.CanalEndoscopeList[i], pae, Canal, CanalEntity);
                    await db.canals.update(ee.CanalIds[i], pae);

                    for (let j = 0; j < endo.CanalEndoscopeList[i].Prelevement.FlaconList.length; j++) {
                        let fe = await this.flaconRepository.getFlaconEntityByCode(endo.CanalEndoscopeList[i].Prelevement.FlaconList[j].Code);
                        if (fe && fe.Id) {
                            mapper.mutate(endo.CanalEndoscopeList[i].Prelevement.FlaconList[j], fe, Flacon, FlaconEntity);
                            await db.flacons.update(fe.Id, endo.CanalEndoscopeList[i].Prelevement.FlaconList[j]);
                        }
                    }
                }
            }
        }

        mapper.mutate(endo, ee, Endoscope, EndoscopeEntity);
        await db.endoscopes.update(ee.Id, ee);

        return true;
    }
}